import React, { useEffect } from "react";
import "./modalslideover.css";

export default function ModalSlideOver({ open, title, onClose, children, footer }) {
  useEffect(() => {
    if (!open) {
      return;
    }

    const previousOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  return (
    <div className={`so-root ${open ? "open" : ""}`} aria-hidden={!open}>
      <div className="so-backdrop" onClick={onClose} />

      <aside
        className="so-panel"
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <header className="so-header">
          <h3>{title}</h3>

          <button
            type="button"
            className="so-close"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </header>

        <div className="so-body">{children}</div>

        {footer && <footer className="so-footer">{footer}</footer>}
      </aside>
    </div>
  );
}
